import { platformFetch } from "services/platformFetch";
import { auth } from "services/firebase";
import adminEmails from "data/adminEmails.json";

// Used only for navigation; the backend independently verifies every admin request.
export const canShowAdmin = (user) =>
  Boolean(
    user?.emailVerified &&
      (user.access
        ? user.access.active &&
          user.access.functions?.includes("admin") &&
          user.access.adminTools?.length > 0
        : adminEmails.includes(
            String(user.email || "")
              .trim()
              .toLowerCase()
          ))
  );

const request = async (path, options = {}) => {
  const user = auth?.currentUser;
  if (!user) throw new Error("Entre na sua conta para continuar.");
  const token = await user.getIdToken();
  const response = await platformFetch(path, {
    ...options,
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok)
    throw new Error(
      body.message || `Nao foi possivel consultar as categorias (HTTP ${response.status}).`
    );
  return body;
};

export const getCategorySession = () => request("/api/session");
export const getApprovedCategories = () => request("/api/book-categories");
export const suggestCategory = (suggestion) =>
  request("/api/category-suggestions", { method: "POST", body: JSON.stringify(suggestion) });
export const getCategorySuggestions = (status = "pending", page = 1) =>
  request(`/api/admin/category-suggestions?${new URLSearchParams({ status, page })}`);
export const reviewCategorySuggestion = (id, decision, note) =>
  request(`/api/admin/category-suggestions/${id}/review`, {
    method: "POST",
    body: JSON.stringify({ decision, note }),
  });
